export const documentReady = (fn) => {
  document.addEventListener("DOMContentLoaded", fn);
  document.addEventListener("turbolinks:load", fn);
};
